import { type Ref, ref } from 'vue'
import { type ActiveLoader, type Props, useLoading } from 'vue-loading-overlay'

export interface Loader {
	show(): ActiveLoader
	hide(): void
	active: Ref<boolean>
}

export const props: Props = {
	active: true,
	canCancel: false,
	// isFullPage: true,
	transition: 'fade',
	//color: '#47a9c2',
	color: '#383838',
	//color: '#e4e8e9',
	//color: 'rgba(74,168,195,0.8)''
	height: 100,
	width: 100,
	loader: 'bars',
	//backgroundColor: '#252525',
	//backgroundColor: 'rgba(74,168,195)',
	backgroundColor: '#e4e8e9',
	opacity: 0.666,
	zIndex: 9000,
	enforceFocus: true,
	lockScroll: true,
	pauseOnHover: false
}

export function useLoader(): Loader {
	let loader: ActiveLoader
	const active = ref(false)
	const $loading = useLoading({
		opacity: 0.9,
		canCancel: false,
		// isFullPage: true,
		onCancel: () => hide()
	})

	function show(): ActiveLoader {
		if (active.value) {
			return loader
		}
		loader = $loading.show(props)
		active.value = true
		return loader
	}
	function hide(): void {
		if (loader && active.value) {
			try {
				loader.hide()
			} catch (e) {
				console.error(e)
			}
		}
		active.value = false
	}
	return { show, hide, active }
}
